import { ArrowLeft01Icon } from "@porchpass/ui";
import SplashPageLayout from "../layouts/SplashPageLayout";

export default () => {
  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <SplashPageLayout>
      <h2 className="text-sm text-[#1453f5]">404 ERROR</h2>
      <h1
        className="text-[75px] text-[#111827] max-sm:text-[40px]"
        data-replay-safe
      >
        Page not found.
      </h1>
      <p className="mt-6 text-[#4a5466]" data-replay-safe>
        Sorry, we couldn’t find the page you’re looking for.
      </p>
      <div className="mt-5 flex flex-wrap justify-center gap-4 max-sm:flex-col">
        <button
          className="flex w-[230px] cursor-pointer items-center justify-center gap-2 rounded-[40px] border border-[#005cd6] bg-gradient-to-b from-[#3c6ff4] to-[#3265ea] p-4 text-base text-white hover:outline-4 hover:outline-[#1453f52e] active:outline-4 active:outline-[#1453f52e] [&_svg]:fill-white"
          onClick={handleGoBack}
        >
          <ArrowLeft01Icon
            variant="stroke-sharp"
            size={33}
            className="-m-[7.5px] text-white"
          />{" "}
          Go back
        </button>
      </div>
    </SplashPageLayout>
  );
};
